// extracted by mini-css-extract-plugin
export default {"container":"components-navigation-account-trigger-module__container"};